module.exports = __webpack_public_path__ + "static/media/ic_categories_car.d79a2e96.svg";